import React from 'react';
import PageHeader from '../components/PageHeader';
import Contact from '../components/Contact';
import usePageMeta from '../utils/usePageMeta';

const ContactPage = () => {
  usePageMeta('Contact Fedigma: Website, ERP & Marketing for Institutes', 'Get a free consultation and a fixed quote for your website, app or school management system. Call, email or WhatsApp Fedigma.');

  return (
    <>
      <PageHeader
        eyebrow="Contact"
        title="Let's talk about your project."
        subtitle="Tell us what you're planning. We'll reply within one business day with next steps and a free consultation."
      />
      <Contact />
    </>
  );
};

export default ContactPage;
